import type { MutationHookOptions } from '@apollo/client'
import {
  UpdateTrainingRequestDocument,
  UpdateTrainingRequestMutation,
  UpdateTrainingRequestMutationVariables,
  MyRequestsDataCollectionDocument,
  MyTrainingRequestsDocument,
  MyTrainingRequestActivityDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpdateTrainingRequestMutation,
  UpdateTrainingRequestMutationVariables
>

export const useUpdateTrainingRequest = (options?: Options) => {
  const [updateTrainingRequest, { loading }] = useMutation(UpdateTrainingRequestDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.updateTrainingsTrainingRequest,
  })

  return {
    loading,
    update(variables: UpdateTrainingRequestMutationVariables) {
      return updateTrainingRequest({
        variables,
        refetchQueries: [
          MyRequestsDataCollectionDocument,
          MyTrainingRequestsDocument,
          MyTrainingRequestActivityDocument,
          ...(Array.isArray(options?.refetchQueries) ? options.refetchQueries : []),
        ],
        awaitRefetchQueries: true,
      })
    },
  }
}
